import React from 'react';
import { Tag } from 'lucide-react';
import TravelKitIllustration from './TravelKitIllustration';
import { EyeMaskIcon, EarplugsIcon, NeckPillowIcon, SockIcon, ToothbrushIcon } from './TravelKitIcons';
import './TravelKitShowcase.css';

const CONTENTS = [
  { Icon: EyeMaskIcon, label: 'Eye mask' },
  { Icon: EarplugsIcon, label: 'Earplugs' },
  { Icon: NeckPillowIcon, label: 'Inflatable neck pillow' },
  { Icon: SockIcon, label: 'Socks' },
  { Icon: ToothbrushIcon, label: 'Travel toothbrush' },
  { Icon: Tag, label: 'Branded Faye bag tag' },
];

export default function TravelKitShowcase() {
  return (
    <section className="tp-travel-kit container">
      <div className="tp-travel-kit__art tile">
        <TravelKitIllustration />
      </div>
      <div className="tp-travel-kit__content">
        <h2 className="headline-2 tp-travel-kit__title">Meet the Faye travel kit</h2>
        <p className="body-l tp-travel-kit__subhead">
          A dark violet tote, packed for the flight — everything you need to actually enjoy it.
        </p>
        <ul className="tp-travel-kit__contents">
          {CONTENTS.map(({ Icon, label }) => (
            <li key={label}>
              <span className="tp-travel-kit__icon"><Icon size={24} strokeWidth={1.5} /></span>
              <span className="body-m">{label}</span>
            </li>
          ))}
        </ul>
        <p className="body-s tp-travel-kit__note">Included with Plus (1 kit) and Max (2 kits).</p>
      </div>
    </section>
  );
}
